import { render, staticRenderFns } from "./CoSkeleton.vue?vue&type=template&id=68c3dcdc&scoped=true&"
import script from "./CoSkeleton.vue?vue&type=script&lang=ts&"
export * from "./CoSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./CoSkeleton.vue?vue&type=style&index=0&id=68c3dcdc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c3dcdc",
  null
  
)

export default component.exports